import {
  submitSaveAdsForLaunch,
  submitFBAdsForPosting,
  fetchFBAdLaunchLogs,
  launchSingleFBAdsByLaunchId,
  submitSaveQuickLaunchAdsForLaunch,
} from "@services/ml/submitSaveAdsForLaunch"
import { notify } from "@utils/notify"
import { getMultipleJobsStatus } from "src/services/ml/syncAndProcessFolder"

const useRQAdLaunches = () => {
  const userId = localStorage.getItem("userId")

  const handleSaveAdLaunches = async (data) => {
    try {
      const response = await submitSaveAdsForLaunch(data)
      return response.data
    } catch (error) {
      console.error("Error saving ad launches:", error)
      notify("Error saving Ad launches", "error")
    }
  }

  const QuickLaunchAdsLaunches = async (data) => {
    try {
      const response = await submitSaveQuickLaunchAdsForLaunch(data)
      return response.data
    } catch (error) {
      console.error("Error saving ad launches:", error)
      notify("Error saving Ad launches", "error")
    }
  }

  const handleFBAdsForPosting = async (batchId, retryFailed = false, quick_launch_id = null) => {
    try {
      const response = await submitFBAdsForPosting(batchId, userId, retryFailed, quick_launch_id)
      return response.data
    } catch (error) {
      console.error("Error submitting FB ads for posting:", error)
      notify("Error submitting FB ads for posting", "error")
    }
  }

  const handleFetchFBAdLaunchLogs = async (batchId) => {
    try {
      const response = await fetchFBAdLaunchLogs(batchId)
      console.log("Fetch FB Ad Launch Logs Response:", response)
      return response.data
    } catch (error) {
      console.error("Error fetching FB ad launch logs:", error)
      notify("Error fetching FB ad launch logs", "error")
    }
  }

  const handleLaunchSingleFBAdsByLaunchId = async (launchId) => {
    try {
      const response = await launchSingleFBAdsByLaunchId(launchId)
      return response.data
    } catch (error) {
      console.error("Error launching single FB ads by launch ID:", error)
      notify("Error launching single FB ads", "error")
    }
  }

  const handleGetMultipleJobsStatus = async (jobIds) => {
    try {
      const response = await getMultipleJobsStatus(jobIds)
      return response.data
    } catch (error) {
      console.log("Get jobs post and process multiple jobs status error")
      console.log(error)
    }
  }

  return {
    handleSaveAdLaunches,
    QuickLaunchAdsLaunches,
    handleFBAdsForPosting,
    handleFetchFBAdLaunchLogs,
    handleLaunchSingleFBAdsByLaunchId,
    handleGetMultipleJobsStatus,
  }
}

export default useRQAdLaunches
